import { AppConfigModel } from "../abstract/app-config.model";

export class SalesDocumentType extends AppConfigModel {

    static override CLASS_NAME: string = 'SalesDocumentType';
}
